require("../coord/cartesian/AxisModel");

require("./axis/CartesianAxisView");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/axis.js
// module id = 2125
// module chunks = 1